export const pathSelector = state => state.request.path;
export const querySelector = state => state.request.query;
export const querySelectorRaw = state => {
  const { currentFullUrl } = state.request;
  const [queryString] = currentFullUrl.match(/\?([^#]+)/) || '';
  return queryString || '';
};

export const fullPathSelector = state => {
  const { currentFullUrl, hostname } = state.request;

  return currentFullUrl.replace(new RegExp(`^https?://${hostname}(:\\d+)?/`), '/');
};
